import React, { useEffect, useState } from 'react';
import {  useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { Carousel, Modal } from 'react-bootstrap';
import axios from 'axios';

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)', // Semi-transparent background
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000, // Ensures the modal is above other content
  },
  modal: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '5px',
    position: 'relative',
    maxWidth: '600px',
    width: '100%',
  },
  image: {
    width: '100%',
    height: 'auto',
  },
  closeButton: {
    cursor: 'pointer',
    border: 'none',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    margin: '0',
    background: 'transparent',
  },
};
const AirtelPaymentVendorDetail = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [showCarousel, setShowCarousel] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  
  const [isModalOpens, setIsModalOpens] = useState(false);
  const [selectedImages, setSelectedImages] = useState('');

const [showHistoryCarousel, setShowHistoryCarousel] = useState(false);
const [activeHistoryIndex, setActiveHistoryIndex] = useState(null);
const [currentHistoryImageIndex, setCurrentHistoryImageIndex] = useState(0);
  const openModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setIsModalOpen(true);
  };
  const handleHistoryImageClick = (historyIndex, imageIndex) => {
  setActiveHistoryIndex(historyIndex);
  setCurrentHistoryImageIndex(imageIndex);
  setShowHistoryCarousel(true);
};

const handleCloseHistoryCarousel = () => {
  setShowHistoryCarousel(false);
  setActiveHistoryIndex(null);
};


  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage('');
  };
    const closeModals = () => {
    setIsModalOpens(false);
    setSelectedImages('');
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`https://amaapi.outdoorooh.com/api/fresh-projects/${id}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        setUser(response.data.data);
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    };

    fetchUser();
  }, [id]);

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setShowCarousel(true);
  };

  const baseUrl = 'https://amaapi.outdoorooh.com/';

  const handleCloseCarousel = () => setShowCarousel(false);
  // Export Table Data to Excel
  const exportToExcel = () => {
    const tableData = [
      ['Name', user.project],
      ['Zone', user.zone],
      ['State', user.state],
      ['Area', user.area],
      ['Code', user.code],
      ['Vendor Name', user.vendor_name],
      ['Lat', user.lat],
      ['Long', user.long],
      ['Length', user.length],
      ['Width', user.width],
      ['Availability', user.availability],
      ['Media Type', user.media_type],
      ['Remarks', user.remarks],
      ['Deviation', user.address],
      ['Total Sqft.', user.total],
      ['ASM Name', user.asm_name],
      ['Type', user.type],
      ['Recce Person Name', user.racce_person_name],
      [
        'Recce Person Image',
        {
          f: `HYPERLINK("${baseUrl}${user.racce_person_image}", "${baseUrl}${user.racce_person_image}")`,
        },
      ],

      ['Image1', { f: `HYPERLINK("${baseUrl}${user.image1}", "${baseUrl}${user.image1}")` }],
    ];

    const ws = XLSX.utils.aoa_to_sheet(tableData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Project Details');
    XLSX.writeFile(wb, 'Project_Details.xlsx');
  };
  console.log(user, 'lll');
  // Print the Table Data
  const printTable = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
      <head>
        <title>Print Table</title>
        <style>
          @page {
            margin: 0;
          }
          body {
            margin: 1cm; 
          }
            h4{
            margin-bottom:5px;
            margin-top:5px;
            }
            body::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
            font-size: 80px;
            color: rgba(0, 0, 0, 0.1);
            z-index: -1;
            white-space: nowrap;
          }
          table {
            width: 100%; 
            border-collapse: collapse;
          }
          tr, td {
            border: 1px solid #ddd; 
            padding: 8px;
          }
            th, td .image-big{
            position:absolute;
            top:10px;
            }
          th {
            background-color: #f2f2f2;
          }
          h1 {
            text-align: center;
          }
                .no-border {
            border: none;
            position :relative;
          }
            .h4-head-p{
            display:flex;}
        </style>
      </head>
        <body>
          <h3 className="h4-head-p" style="margin-bottom:30px">Site Name : ${
            user.site_name ?? ""
          } &nbsp; &nbsp; Code : ${user.code ?? ""}</h3>
          
          <table>
            <tbody>
              <tr>
                    <td><strong>Zone</strong></td>
                <td>${user.zone ?? ""}</td>
                <td><strong>State</strong></td>
                <td>${user.state ?? ""}</td>
                <td><strong>Area</strong></td>
                <td>${user.area ?? ""}</td>
               
              </tr>
              <tr>
                  <td><strong>Start Date</strong></td>
                <td>${user.start_date ?? ""}</td>
                    <td><strong>End Date</strong></td>
                <td>${user.end_date ?? ""}</td>
                  <td width="200"><strong>Vendor Name</strong></td>
                <td>${user.vendor_name ?? ""}</td>
              </tr>
              <tr>
                <td><strong>Height</strong></td>
                <td>${user.length ?? ""}</td>
                 <td width="200"><strong>Width</strong></td>
                <td width="200">${user.width ?? ""}</td>
                  <td><strong>Unit</strong></td>
                <td>: ${user.unit ?? ""}</td>
               
               
              </tr>
              <tr>
               <td><strong>Total Sqft.</strong></td>
                <td>${user.total ?? ""}</td>
                <td><strong>Lat</strong></td>
                <td>${user.lat ?? ""}</td>
                <td width="200"><strong>Long</strong></td>
                <td width="200">${user.long ?? ""}</td>
                
              
              </tr>

                <tr>
<td><strong>Availability</strong></td>
<td>${user.availability ?? ""}</td>
              <td><strong>Vendor Status</strong></td>
                <td>${user.vendor_status ?? ""} ${(() => {
      const dateString = user.vendor_approval_date;
      if (!dateString) return '';
      const cleanDate = dateString.split(' ')[0];

      // Handle DD/MM/YYYY format (no changes needed)
      if (/\d{2}\/\d{2}\/\d{4}/.test(cleanDate)) {
        return cleanDate; // Return DD/MM/YYYY as-is
      }

      // Handle DD-MM-YY format (no changes needed)
      if (/\d{2}-\d{2}-\d{2}/.test(cleanDate)) {
        return cleanDate; // Return DD-MM-YY as-is
      }

      // Handle YYYY-MM-DD format or valid ISO date
      const formattedDate = new Date(cleanDate);
      if (formattedDate.toString() !== 'Invalid Date') {
        return formattedDate.toLocaleDateString('en-IN', {
          timeZone: 'Asia/Kolkata',
        });
      }

      return '';
    })() ?? ""}</td>
                
              
                
              <td ><strong>Airtel Team</strong></td>
                <td>${user.client_status ?? ""} ${(() => {
      const dateString = user.rhm_approval_date;
      if (!dateString) return ''; // Return an empty string if no date is provided

      const cleanDate = dateString.split(' ')[0]; // Extract only the date part (before space)

      // Handle DD/MM/YYYY format (no changes needed)
      if (/\d{2}\/\d{2}\/\d{4}/.test(cleanDate)) {
        return cleanDate; // Return DD/MM/YYYY as-is
      }

      // Handle DD-MM-YY format (no changes needed)
      if (/\d{2}-\d{2}-\d{2}/.test(cleanDate)) {
        return cleanDate; // Return DD-MM-YY as-is
      }

      // Handle YYYY-MM-DD format or valid ISO date
      const formattedDate = new Date(cleanDate);
      if (formattedDate.toString() !== 'Invalid Date') {
        return formattedDate.toLocaleDateString('en-IN', {
          timeZone: 'Asia/Kolkata',
        });
      }

      return '';
    })() ?? ""}</td>
                    
              </tr>
              <tr>

              <td width="200">
                <strong>  Type </strong>
                </td>
                <td>: ${user.type ?? ""}</td>

               <td width="200">
                <strong>  Recce Person Name </strong>
                </td>
                <td>: ${user.racce_person_name ?? ""}</td>
                <td width="200" >
                <strong>  Recce Person Image : </strong>
                </td>
                <td >
                   <img src="https://amaapi.outdoorooh.com/${
                     user.racce_person_image
                   }" alt="" width="60" height="60" />
                </td>
                
              </tr>
<tr>
<td >Image Updated Date :</td>
                  <td >
                 
                     ${(() => {
                       const dateString = user.image_last_updated_date;
                       if (!dateString) return ''; // Return an empty string if no date is provided

                       const cleanDate = dateString.split(' ')[0]; // Extract only the date part (before space)

                       // Handle DD/MM/YYYY format (no changes needed)
                       if (/\d{2}\/\d{2}\/\d{4}/.test(cleanDate)) {
                         return cleanDate; // Return DD/MM/YYYY as-is
                       }

                       // Handle DD-MM-YY format (no changes needed)
                       if (/\d{2}-\d{2}-\d{2}/.test(cleanDate)) {
                         return cleanDate; // Return DD-MM-YY as-is
                       }

                       // Handle YYYY-MM-DD format or valid ISO date
                       const formattedDate = new Date(cleanDate);
                       if (formattedDate.toString() !== 'Invalid Date') {
                         return formattedDate.toLocaleDateString('en-IN', {
                           timeZone: 'Asia/Kolkata',
                         });
                       }

                       return ''; // Return an empty string for unrecognized formats
                     })() ?? ""}
                  </td>
                  
                   <td width="200"><strong>Media Type</strong></td>
                <td width="200">${user.media_type ?? ""}</td>
                  </tr>
              <tr>
                <td class="no-border" height="730px">
                  <img src="https://amaapi.outdoorooh.com/${
                    user.image
                  }" alt="" class="image-big" width="700" height="700"  />
                </td>
                
                
              </tr>
            

                  
    
  <body>
          <table>
    <h2 style="border:none; padding-top:50px; margin-bottom:0px;">History</h2>

          ${user.fresh_histories
            .map(
              (item) => `
               
          <h3 >  Image Updated Date :
                 
                  ${(() => {
                    const dateString = item.image_last_updated_date;
                    if (!dateString) return ''; // Return an empty string if no date is provided

                    const cleanDate = dateString.split(' ')[0]; // Extract only the date part (before space)

                    // Handle DD/MM/YYYY format (no changes needed)
                    if (/\d{2}\/\d{2}\/\d{4}/.test(cleanDate)) {
                      return cleanDate; // Return DD/MM/YYYY as-is
                    }

                    // Handle DD-MM-YY format (no changes needed)
                    if (/\d{2}-\d{2}-\d{2}/.test(cleanDate)) {
                      return cleanDate; // Return DD-MM-YY as-is
                    }

                    // Handle YYYY-MM-DD format or valid ISO date
                    const formattedDate = new Date(cleanDate);
                    if (formattedDate.toString() !== 'Invalid Date') {
                      return formattedDate.toLocaleDateString('en-IN', {
                        timeZone: 'Asia/Kolkata',
                      });
                    }

                    return ''; // Return an empty string for unrecognized formats
                  })() ?? ""}
                    
                  </h3>

           

                <div class="no-border" height="990px">
                  <img src="https://amaapi.outdoorooh.com/${
                    item.image
                  }" alt="" class="image-big" width="700" height="960"  />
                </div>
                
                
              `,
            )
            .join('') ?? ""}
              </table>
        </body>
            </tbody>
          </table>
        </body>
      </html>
    `);
    printWindow.onload = () => {
      const { images } = printWindow.document; // Use object destructuring here
      const totalImages = images.length;
      let loadedImages = 0;

      const imageLoaded = () => {
        loadedImages++;
        if (loadedImages === totalImages) {
          printWindow.print();
        }
      };

      for (let i = 0; i < totalImages; i++) {
        images[i].onload = imageLoaded;
        images[i].onerror = imageLoaded; // In case of error, count as loaded
      }

      if (totalImages === 0) {
        printWindow.print();
      }
    };
    printWindow.document.close();
    printWindow.print();
  };

  // history data print and excel

  if (!user) return <div>Loading...</div>;
  // const goToNextValidId = async (currentId) => {
  //   const nextId = currentId + 1;
  //   try {
  //     const res = await axios.get(`https://amaapi.outdoorooh.com/api/fresh-projects/${nextId}`);
  //     if (res.data && res.data.data) {
  //       navigate(`/airtel-payment-project-detail/${nextId}`);
  //     } else {
  //       goToNextValidId(nextId); // Try next ID recursively
  //     }
  //   } catch (error) {
  //     goToNextValidId(nextId); // Skip invalid ID
  //   }
  // };

  // // Recursive helper for Prev
  // const goToPrevValidId = async (currentId) => {
  //   const prevId = currentId - 1;
  //   if (prevId <= 0) return; // Stop at 0

  //   try {
  //     const res = await axios.get(`https://amaapi.outdoorooh.com/api/fresh-projects/${prevId}`);
  //     if (res.data && res.data.data) {
  //       navigate(`/airtel-payment-project-detail/${prevId}`);
  //     } else {
  //       goToPrevValidId(prevId); // Try previous ID recursively
  //     }
  //   } catch (error) {
  //     goToPrevValidId(prevId); // Skip invalid ID
  //   }
  // };
  return (
    <>
     
      <div style={{ background: '#fff', borderRadius: '10px' }}>
        <div className="p-4">
          <div className="d-flex flex justify-content-between">
            <div>
              <h4 className="d-flex">
                <span>Site Name :</span> {user.site_name}, &nbsp; &nbsp;
                <h4>
                  <span>Code :</span> {user.code}
                </h4>
              </h4>
            </div>
            <div>
              <button type="button" onClick={exportToExcel} className="btn btn-primary mb-3 me-2">
                Export to Excel
              </button>
              <button type="button" onClick={printTable} className="btn btn-secondary mb-3">
                Print Table
              </button>
            </div>
          </div>
          <table className="table ">
            <tbody>
              <tr>
                <td width="200">
                  <h6>Zone </h6>
                </td>
                <td>: {user.zone}</td>
                <td width="200">
                  <h6>State </h6>
                </td>
                <td>: {user.state}</td>
                <td width="200">
                  <h6>Area </h6>
                </td>
                <td>: {user.area}</td>

                {/* <td width="200">
                  <h6>Location </h6>
                </td>
                <td width="300">: {user.location}</td> */}
              </tr>

              <tr>
                <td width="200">
                  <h6>Vendor Name </h6>
                </td>
                <td>: {user.vendor_name}</td>
                <td width="200">
                  <h6>Start Date </h6>
                </td>
                <td>: {user.start_date}</td>

                <td width="200">
                  <h6>End Date </h6>
                </td>
                <td>: {user.end_date}</td>
              </tr>

              <tr>
                <td width="200">
                  <h6>Height </h6>
                </td>
                <td>: {user.length}</td>
                <td width="200">
                  <h6>Width </h6>
                </td>
                <td>: {user.width}</td>
                <td width="200">
                  <h6>Unit </h6>
                </td>
                <td>: {user.unit}</td>
              </tr>

              <tr>
                <td width="200">
                  <h6>Total Sqft. </h6>
                </td>
                <td>: {user.total}</td>
                <td width="200">
                  <h6>Lat </h6>
                </td>
                <td>: {user.lat}</td>
                <td width="200">
                  <h6>Long </h6>
                </td>
                <td>: {user.long}</td>
              </tr>
                   <tr>
                <td width="200">
                  <h6>Remarks </h6>
                </td>
                <td>: {user.remarks ? user.remarks : "N/A"}</td>
                <td width="200">
                  <h6>Deviation </h6>
                </td>
                <td>: {user.address ? "Yes" :"No"}</td>
                <td width="200">
                  <h6>Reason </h6>
                </td>
                <td>: {user.address ? user.address : "N/A"}</td>
              </tr>
              <tr>
                <td width="200">
                  <h6>Availability </h6>
                </td>
                <td>: {user.availability}</td>
                <td width="200">
                  <h6>Vendor Status </h6>
                </td>
                <td>
                  : {user.vendor_status}{' '}
                  {(() => {
                    const dateString = user.vendor_approval_date;
                    if (!dateString) return ''; // Return an empty string if no date is provided

                    // Normalize formats and remove time
                    const cleanDate = dateString.split(' ')[0]; // Extract only the date part (before space)

                    // Handle DD/MM/YYYY format (no changes needed)
                    if (/\d{2}\/\d{2}\/\d{4}/.test(cleanDate)) {
                      return cleanDate; // Return DD/MM/YYYY as-is
                    }

                    // Handle DD-MM-YY format (no changes needed)
                    if (/\d{2}-\d{2}-\d{2}/.test(cleanDate)) {
                      return cleanDate; // Return DD-MM-YY as-is
                    }

                    // Handle YYYY-MM-DD format or valid ISO date
                    const formattedDate = new Date(cleanDate);
                    if (formattedDate.toString() !== 'Invalid Date') {
                      return formattedDate.toLocaleDateString('en-IN', {
                        timeZone: 'Asia/Kolkata',
                      });
                    }

                    return ''; // Return an empty string for unrecognized formats
                  })()}
                </td>

                <td width="200">
                  <h6>Airtel Team </h6>
                </td>
                <td>
                  : {user.client_status}{' '}
                  {(() => {
                    const dateString = user.rhm_approval_date;
                    if (!dateString) return ''; // Return an empty string if no date is provided

                    // Normalize formats and remove time
                    const cleanDate = dateString.split(' ')[0]; // Extract only the date part (before space)

                    // Handle DD/MM/YYYY format (no changes needed)
                    if (/\d{2}\/\d{2}\/\d{4}/.test(cleanDate)) {
                      return cleanDate; // Return DD/MM/YYYY as-is
                    }

                    // Handle DD-MM-YY format (no changes needed)
                    if (/\d{2}-\d{2}-\d{2}/.test(cleanDate)) {
                      return cleanDate; // Return DD-MM-YY as-is
                    }

                    // Handle YYYY-MM-DD format or valid ISO date
                    const formattedDate = new Date(cleanDate);
                    if (formattedDate.toString() !== 'Invalid Date') {
                      return formattedDate.toLocaleDateString('en-IN', {
                        timeZone: 'Asia/Kolkata',
                      });
                    }

                    return ''; // Return an empty string for unrecognized formats
                  })()}
                </td>
              </tr>
              <tr>
                  <td width="200">
                  <h6>Type </h6>
                </td>
                <td>: {user.type}</td>
                <td width="200">
                  <h6>Recce Person Name </h6>
                </td>
                <td>: {user.racce_person_name}</td>
                <td width="200">
                  <h6>Recce Person Image </h6>
                </td>
                <td>
                  :{' '}
                  <button
                    type="button"
                    onClick={() =>
                      openModal(`https://amaapi.outdoorooh.com/${user.racce_person_image}`)
                    }
                    style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }} // Optional styling
                  >
                    <img
                      src={`https://amaapi.outdoorooh.com/${user.racce_person_image}`}
                      alt="Person"
                      width={60}
                      height={60}
                      onError={(e) => {
                        e.target.style.display = 'none'; // Hide the broken image
                        e.target.insertAdjacentHTML('afterend', '<span>NA</span>'); // Insert "NA" next to the image
                      }}
                    />
                  </button>
                </td>
              </tr>

              <tr>
                <td width="200">
                  <h6>Media Type </h6>
                </td>
                <td>: {user.media_type}</td>
                <td width="200" className="d-flex gap-2">
                  {user.image ? (
                    <button
                      type="button"
                      style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
                      onClick={() => handleImageClick(0)}
                    >
                      <img
                        src={`https://amaapi.outdoorooh.com/${user.image}`}
                        alt=""
                        width={60}
                        height={60}
                      />
                    </button>
                  ) : (
                    ''
                  )}

                  {user.image1 ? (
                    <button
                      type="button"
                      style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
                      onClick={() => handleImageClick(1)}
                    >
                      <img
                        src={`https://amaapi.outdoorooh.com/${user.image1}`}
                        alt=""
                        width={60}
                        height={60}
                      />
                    </button>
                  ) : (
                    ''
                  )}
                  {user.image2 ? (
                    <button
                      type="button"
                      style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
                      onClick={() => handleImageClick(2)}
                    >
                      <img
                        src={`https://amaapi.outdoorooh.com/${user.image2}`}
                        alt=""
                        width={60}
                        height={60}
                      />
                    </button>
                  ) : (
                    ' '
                  )}
                  {user.image3 ? (
                    <button
                      type="button"
                      style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
                      onClick={() => handleImageClick(3)}
                    >
                      <img
                        src={`https://amaapi.outdoorooh.com/${user.image3}`}
                        alt=""
                        width={60}
                        height={60}
                      />
                    </button>
                  ) : (
                    ''
                  )}

                  {user.image4 ? (
                    <button
                      type="button"
                      style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
                      onClick={() => handleImageClick(4)}
                    >
                      <img
                        src={`https://amaapi.outdoorooh.com/${user.image4}`}
                        alt=""
                        width={60}
                        height={60}
                      />
                    </button>
                  ) : (
                    ''
                  )}
                  <td style={{ minWidth: '230px' }}>Image Updated Date :</td>
                  <td style={{ minWidth: '230px' }}>
                    {(() => {
                      const dateString = user.image_last_updated_date;
                      if (!dateString) return ''; // Return an empty string if no date is provided

                      // Normalize formats and remove time
                      const cleanDate = dateString.split(' ')[0]; // Extract only the date part (before space)

                      // Handle DD/MM/YYYY format (no changes needed)
                      if (/\d{2}\/\d{2}\/\d{4}/.test(cleanDate)) {
                        return cleanDate; // Return DD/MM/YYYY as-is
                      }

                      // Handle DD-MM-YY format (no changes needed)
                      if (/\d{2}-\d{2}-\d{2}/.test(cleanDate)) {
                        return cleanDate; // Return DD-MM-YY as-is
                      }

                      // Handle YYYY-MM-DD format or valid ISO date
                      const formattedDate = new Date(cleanDate);
                      if (formattedDate.toString() !== 'Invalid Date') {
                        return formattedDate.toLocaleDateString('en-IN', {
                          timeZone: 'Asia/Kolkata',
                        });
                      }

                      return ''; // Return an empty string for unrecognized formats
                    })()}
                  </td>
                </td>
               
              </tr>
            </tbody>
          </table>
          <Modal className="custom-modal" show={showCarousel} onHide={handleCloseCarousel}>
            <Modal.Header className="header-m">
              <button type="button" className="cross" onClick={handleCloseCarousel}>
                x
              </button>
            </Modal.Header>
            <Modal.Body>
              <Carousel
                activeIndex={currentImageIndex}
                onSelect={(selectedIndex) => setCurrentImageIndex(selectedIndex)}
              >
                {[user.image, user.image1, user.image2, user.image3, user.image4].map((img) => (
                  <Carousel.Item key={img}>
                    <img className="" src={`https://amaapi.outdoorooh.com/${img}`} alt="Slide" />
                  </Carousel.Item>
                ))}
              </Carousel>
            </Modal.Body>
          </Modal>

        

          {isModalOpen && (
            <div style={modalStyles.overlay}>
              <div style={modalStyles.modal}>
                <button
                  onClick={closeModal}
                  type="button"
                  className="primary mb-2"
                  style={modalStyles.closeButton}
                >
                  x
                </button>
                <img src={selectedImage} alt="Preview" style={modalStyles.image} />
              </div>
            </div>
          )}

           {isModalOpens && (
            <div style={modalStyles.overlay}>
              <div style={modalStyles.modal}>
                <button
                  onClick={closeModals}
                  type="button"
                  className="primary mb-2"
                  style={modalStyles.closeButton}
                >
                  x
                </button>
                <img src={selectedImages} alt="Preview" style={modalStyles.image} />
              </div>
            </div>
          )}
        </div>
      </div>

      <h2 style={{ marginTop: '50px' }}>History</h2>
     


{user?.fresh_histories?.map((hista, historyIndex) => (
  <div
    style={{ background: '#fff', borderRadius: '10px', marginTop: '20px' }}
  >
    <div className="p-4">
      <td style={{ minWidth: '230px' }}>
        Image Updated Date: {hista.image_last_updated_date.split(' ')[0]}
      </td>

      <table className="table">
        <tbody>
          <tr>
            <td width="200" className="d-flex gap-2">
              {[hista.image, hista.image1, hista.image2, hista.image3, hista.image4].map(
                (img, imgIndex) =>
                  img ? (
                    <button
                      type="button"
                      style={{
                        border: 'none',
                        background: 'none',
                        padding: 0,
                        cursor: 'pointer',
                      }}
                      onClick={() => handleHistoryImageClick(historyIndex, imgIndex)}
                    >
                      <img
                        src={`${baseUrl}${img}`}
                        alt=""
                        width={60}
                        height={60}
                      />
                    </button>
                  ) : null
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
))}
<Modal className="custom-modal" show={showHistoryCarousel} onHide={handleCloseHistoryCarousel}>
  <Modal.Header className="header-m">
    <button type="button" className="cross" onClick={handleCloseHistoryCarousel}>
      x
    </button>
  </Modal.Header>
  <Modal.Body>
    {activeHistoryIndex !== null && (
      <Carousel
        activeIndex={currentHistoryImageIndex}
        onSelect={(selectedIndex) => setCurrentHistoryImageIndex(selectedIndex)}
      >
        {[user.fresh_histories[activeHistoryIndex].image,
          user.fresh_histories[activeHistoryIndex].image1,
          user.fresh_histories[activeHistoryIndex].image2,
          user.fresh_histories[activeHistoryIndex].image3,
          user.fresh_histories[activeHistoryIndex].image4
        ].map(
          (img) =>
            img && (
              <Carousel.Item key={img}>
                <img
                  className=""
                  src={`${baseUrl}${img}`}
                  alt="Slide"
                />
              </Carousel.Item>
            )
        )}
      </Carousel>
    )}
  </Modal.Body>
</Modal>

         
    </>
  );
};

export default AirtelPaymentVendorDetail;
